export * from "./i18n";

/** Add the language flag to the specified url */
export const getLocalizedURL = (url: string, language: string) => {
  return url.includes("?")
    ? `${url}&lng=${language}`
    : `${url}?lng=${language}`;
};

/** Update the window url to include the language flag */
export const setLocalizedURL = (language: string) => {
  const url = new URL(window.location as any);
  url.searchParams.set('lng', language);
  window.history.pushState({}, '', url as any);
};
